import * as React from "react";

const Help: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
                <g fill="#002856" fillRule="nonzero">
                    <path d="M16 0C7.15 0 0 7.15 0 16s7.15 16 16 16 16-7.15 16-16S24.85 0 16 0zm0 30C8.301 30 2 23.699 2 16S8.301 2 16 2s14 6.301 14 14-6.301 14-14 14z" />
                    <path d="M16.301 6c-1.65-.1-3.25.5-4.45 1.65-1.2 1.15-1.85 2.7-1.85 4.35h2c0-1.1.448-2.15 1.25-2.9.8-.75 1.849-1.15 2.948-1.1 2 .1 3.65 1.75 3.801 3.8.1 1.6-.8 3.1-2.25 3.802-1.699.85-2.75 2.5-2.75 4.3V20h2v-.1c0-1.05.65-2 1.65-2.5 2.151-1.05 3.5-3.3 3.35-5.699-.15-3.05-2.65-5.55-5.699-5.7V6zM15 24L17 24 17 26 15 26z" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Help);
